import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { useMutation, useQueryClient } from 'react-query'
import withApiData from '../../HOC/withApiData'
const IconButton = require('@material-ui/core/IconButton').default
const Menu = require('@material-ui/core/Menu').default
const MenuItem = require('@material-ui/core/MenuItem').default
const MoreVertIcon = require('@material-ui/icons/MoreVert').default
import { showModal } from '../../../actions/modal'
import { deleteMentorActivityCourse } from '../../mycourses/API'

const options = ['Edit Details', 'Delete']

const ITEM_HEIGHT = 48

const MenuButton = ({
  apiData,
  activityCourse,
  journeyQuantity,
  academicYears,
  selectedAcademicYearId
}) => {
  const dispatch = useDispatch()
  const gradeLevels = useSelector(state => state.gradelevels.items)
  const gradeLevel = gradeLevels.find(gl => gl.id === activityCourse.grade_level_id)

  const queryClient = useQueryClient()
  const deleteMutation = useMutation(({ apiData, id }) =>
    deleteMentorActivityCourse(apiData, id)
  )

  const onDeleteClick = (apiData, id) => {
    deleteMutation.mutate(
      {
        apiData,
        id
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries('mentor-master-courses-' + selectedAcademicYearId)
          queryClient.invalidateQueries('cloneable-master-courses')
        }
      }
    )
  }

  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = option => {
    if (option === 'Delete') {
      if (journeyQuantity === 0) {
        dispatch(showModal(
          'CLOSE_MODAL',
          {
            activityCourse: activityCourse,
            gradeLevel: gradeLevel,
            description: 'Are you sure you want to delete this course ?',
            supportiveText: 'Once deleted, this cannot be undone.',
            deleteFunction: () => onDeleteClick(apiData, activityCourse.id)
          })
        )
      } else {
        dispatch(showModal(
          'INFORMATIVE_MODAL',
          {
            activityCourse: activityCourse,
            description: 'All journeys in this course must be deleted before you can delete the course.',
            gradeLevel: gradeLevel
          })
        )
      }
    }

    if (option === 'Edit Details') {
      dispatch(showModal(
        'EDIT_COURSE_MODAL',
        {
          activityCourse: activityCourse,
          apiData: apiData,
          academicYears: academicYears,
          selectedAcademicYearId: selectedAcademicYearId
        })
      )
    }

      setAnchorEl(null)
  }

  return (
    <div className='menu-button'>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
        style={{ width: '48px' }}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: '20ch'
          }
        }}
      >
        {options.map(option => (
          <MenuItem
            key={option}
            onClick={() => handleClose(option)}
          >
            {option}
          </MenuItem>
        ))}
      </Menu>
    </div>
  )
}

MenuButton.propTypes = {
  apiData: PropTypes.object.isRequired,
  activityCourse: PropTypes.object.isRequired,
  journeyQuantity: PropTypes.number.isRequired,
  academicYears: PropTypes.array.isRequired,
  selectedAcademicYearId: PropTypes.number.isRequired
}

export default withApiData(MenuButton)



// WEBPACK FOOTER //
// ./src/components/mini/Buttons/MenuButton.js